<template>
  <div class="part-item projectBuilding">
    <p class="part-title">实验教学课程持续建设服务计划
      <a
        v-show="isShow"
        href="javascript:;"
        @click="clearItem('service')"
      ><i class="icon iconfont">&#xe614;</i>清空</a>
      <a
        v-show="isShow"
        href="javascript:;"
        @click="openService"
      ><i class="icon iconfont">&#xe660;</i>编辑</a>
    </p>
    <div class="part-content">
      <span class="content-title">课程持续建设</span>
      <div
        v-if="!formInfo.service_plan.buildArry"
        class="content-text"
      >：暂无内容</div>
      <div class="clearfix"></div>
      <div
        class="content-text-table"
        v-if="formInfo.service_plan.buildArry"
      >
        <table class="part-new-table">
          <tbody>
            <tr>
              <th
                class="th1"
                width="90"
              >日期</th>
              <th class="th2">描述</th>
            </tr>
            <tr
              class="continue-build-data"
              v-for="(item,index) in formInfo.service_plan.buildArry"
              :key="index"
            >
              <td>{{item.yaer}}</td>
              <td>{{item.describe}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">其他描述：</span>
      <div
        class="content-text"
        v-if="formInfo.service_plan.buildDescribe"
        v-html="formInfo.service_plan.buildDescribe"
      ></div>
      <div
        v-else
        class="content-text"
      >暂无内容</div>
      <div class="clearfix"></div>
      <span class="content-title">面向高校、社会的教学推广应用计划</span>
      <div
        v-if="!formInfo.service_plan.planArry"
        class="content-text"
      >：暂无内容</div>
      <div class="clearfix"></div>
      <div
        class="content-text-table"
        v-if="formInfo.service_plan.planArry"
      >
        <table class="part-new-table">
          <tbody>
            <tr>
              <th width="90">日期</th>
              <th>推广高校数</th>
              <th>应用人数</th>
              <th>推广行业数</th>
              <th>应用人数</th>
            </tr>
            <tr
              class="share-plan-data"
              v-for="(item,index) in formInfo.service_plan.planArry"
              :key="index"
            >
              <td>{{item.yaer}}</td>
              <td>{{item.university}}</td>
              <td>{{item.universityCound}}</td>
              <td>{{item.extend}}</td>
              <td>{{item.extendCount}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="clearfix"></div>
      <span class="content-title">其他描述：</span>
      <div
        class="content-text"
        v-if="formInfo.service_plan.planDescribe"
        v-html="formInfo.service_plan.planDescribe"
      ></div>
      <div
        v-else
        class="content-text"
      >暂无内容</div>
    </div>

    <div
      class="form_overlay"
      id="feature_overlay"
      :style="formatShowWindow(showWindow.service)"
    >
      <div class="form_overlay_bg"></div>
      <div
        class="form_panel editor"
        style=""
      >
        <div class="form_title">实验教学课程持续建设服务计划</div>
        <a
          href="javascript:void(0)"
          @click="showWindow.service = false"
          class="overlay-close"
        ><i class="iconfont"></i></a>
        <div
          class="form_content"
          style=""
        >
          <form
            id="featureForm"
            style=""
          >
            <div class="item">
              <span class="label"><i class="require"></i>课程持续建设</span>
              <div class="k-container continue-build">
                <table class="item-table">
                  <tbody>
                    <tr>
                      <th width="90">日期</th>
                      <th>描述</th>
                    </tr>
                    <tr
                      class="continue-build-data"
                      v-for="(item,index) in formService.buildArry"
                      :key="index"
                    >
                      <td>{{item.yaer}}</td>
                      <td>
                        <input
                          v-model="item.describe"
                          type="text"
                          autocomplete="new-password"
                          maxlength="25"
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>其他描述</span>
              <vue-ueditor-wrap
                style="margin-left:130px"
                v-model="formService.buildDescribe"
                :config="editorConfig"
                editor-id="editor-demo-23"
              ></vue-ueditor-wrap>
            </div>
            <div class="item">
              <span class="label"><i class="require"></i>面向高校、社会的教学推广应用计划</span>
              <div class="k-container share-plan">
                <table class="item-table">
                  <tbody>
                    <tr>
                      <th width="90">日期</th>
                      <th>推广高校数</th>
                      <th>应用人数</th>
                      <th>推广行业数</th>
                      <th>应用人数</th>
                    </tr>
                    <tr
                      class="share-plan-data"
                      v-for="(item,index) in formService.planArry"
                      :key="index"
                    >
                      <td>{{item.yaer}}</td>
                      <td>
                        <input
                          v-model="item.university"
                          type="number"
                          autocomplete="new-password"
                          maxlength="10"
                        >
                      </td>
                      <td>
                        <input
                          v-model="item.universityCound"
                          type="number"
                          autocomplete="new-password"
                          maxlength="10"
                        >
                      </td>
                      <td>
                        <input
                          v-model="item.extend"
                          type="number"
                          autocomplete="new-password"
                          maxlength="10"
                        >
                      </td>
                      <td>
                        <input
                          v-model="item.extendCount"
                          type="number"
                          autocomplete="new-password"
                          maxlength="10"
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              class="item"
              style=""
            >
              <span class="label"><i class="require"></i>其他描述</span>
              <vue-ueditor-wrap
                style="margin-left:130px"
                v-model="formService.planDescribe"
                :config="editorConfig"
                editor-id="editor-demo-24"
              ></vue-ueditor-wrap>
            </div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            @click="showWindow.service = false"
            class="button close"
            id="feature_close"
          >取消</a>
          <a
            href="javascript:;"
            @click="saveService(1)"
            class="button"
            id="feature_submit"
          >提交</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'

export default {
  name: 'ExperimentMaintainServicePlan',
  props: ['isShow', 'expId'],
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      editorConfig: {
        UEDITOR_HOME_URL: '/UE/',
        serverUrl: this.$store.state.uEditorServerUrl,
        autoHeight: true,
        initialFrameWidth: '100%',
        initialFrameHeight: 300
      },
      formInfo: {
        service_plan: ''
      },
      showWindow: {
        service: false
      },
      formService: {
        buildArry: [
          { yaer: '第一年', describe: '' },
          { yaer: '第二年', describe: '' },
          { yaer: '第三年', describe: '' },
          { yaer: '第四年', describe: '' },
          { yaer: '第五年', describe: '' }
        ],
        buildDescribe: '',
        planArry: [
          { yaer: '第一年', university: '', universityCound: '', extend: '', extendCount: '' },
          { yaer: '第二年', university: '', universityCound: '', extend: '', extendCount: '' },
          { yaer: '第三年', university: '', universityCound: '', extend: '', extendCount: '' },
          { yaer: '第四年', university: '', universityCound: '', extend: '', extendCount: '' },
          { yaer: '第五年', university: '', universityCound: '', extend: '', extendCount: '' }
        ],
        planDescribe: ''
      },
      sensitiveWord: []
    }
  },
  methods: {
    formatShowWindow(tag) {
      if (tag) {
        return {
          visibility: 'visible'
        }
      } else {
        return {}
      }
    },
    async getInfo() {
      const url = '/allowany/experiment/' + this.expId + '/'
      await this.$http.get(url).then(async (data) => {
        this.formInfo = data
        this.formInfo.service_plan = data.service_plan ? JSON.parse(data.service_plan) : ''
      }).catch((error) => {
        console.log(error)
      })
    },
    openService() {
      if (this.formInfo.service_plan) {
        this.formService = JSON.parse(JSON.stringify(this.formInfo.service_plan))
      }
      this.showWindow.service = true
    },
    async saveService(type) {
      var ischeck = true
      // this.formService.buildArry.forEach(element => {
      //   if (!element.describe) {
      //     ischeck = false
      //     this.$layer.msg('请完善课程持续建设列表')
      //   }
      // })
      // this.formService.planArry.forEach(element => {
      //   if (!element.university || !element.universityCound || !element.extend || !element.extendCount) {
      //     ischeck = false
      //     this.$layer.msg('请完善面向高校、社会的教学推广应用计划列表')
      //   }
      // })
      const buildDescribe = this.utils.getWords(this.formService.buildDescribe, this.sensitiveWord)
      const planDescribe = this.utils.getWords(this.formService.planDescribe, this.sensitiveWord)
      if (buildDescribe) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      if (planDescribe) {
        this.$layer.msg('输入的内容有敏感词!')
        return false
      }
      if (ischeck) {
        const url = '/experiment/' + this.expId + '/'
        await this.$http.put(url, {
          service_plan: type ? JSON.stringify(this.formService) : ''
        }).then((data) => {
          if (data.id) {
            this.formInfo.service_plan = type ? JSON.parse(data.service_plan) : ''
            if (!type) {
              this.formService = {
                buildArry: [
                  { yaer: '第一年', describe: '' },
                  { yaer: '第二年', describe: '' },
                  { yaer: '第三年', describe: '' },
                  { yaer: '第四年', describe: '' },
                  { yaer: '第五年', describe: '' }
                ],
                buildDescribe: '',
                planArry: [
                  { yaer: '第一年', university: '', universityCound: '', extend: '', extendCount: '' },
                  { yaer: '第二年', university: '', universityCound: '', extend: '', extendCount: '' },
                  { yaer: '第三年', university: '', universityCound: '', extend: '', extendCount: '' },
                  { yaer: '第四年', university: '', universityCound: '', extend: '', extendCount: '' },
                  { yaer: '第五年', university: '', universityCound: '', extend: '', extendCount: '' }
                ],
                planDescribe: ''
              }
            }
            this.showWindow.service = false
          } else {
            this.$layer.msg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })
      }
    },
    clearItem(categgory) {
      switch (categgory) {
        case 'introduce':
          this.formIntroduce = {
            brief: ''
          }
          this.saveIntroduce()
          break
        case 'tech_goal':
          this.formTechGoal = {
            tech_goal: ''
          }
          this.saveTechGoal()
          break
        case 'class_hour':
          this.formClassHour = {
            time_lesson: '',
            time_experiment: ''
          }
          this.saveClassHour()
          break
        case 'theory':
          this.formTheory = {
            theory_content: '',
            theory_point: ''
          }
          this.saveTheory()
          break
        case 'device':
          this.formDevice = {
            device: ''
          }
          this.saveDevice()
          break
        case 'materials':
          this.formMaterials = {
            materials: ''
          }
          this.saveMaterials()
          break
        case 'tech_func':
          this.formTechFunc = {
            tech_func: ''
          }
          this.saveTechFunc()
          break
        case 'step':
          this.formStep = {
            step_claim_des: '',
            step_claim_step: '',
            step_claim_step_des: ''
          }
          this.saveStep()
          break
        case 'result':
          this.formResult = {
            result_claim_record: 0,
            result_claim_type_ck1: false,
            result_claim_type_ck2: false,
            result_claim_type_ck3: false,
            result_claim_type_ck3_text: '',
            result_claim_content: ''
          }
          this.saveResult()
          break
        case 'check_claim':
          this.formCheckClaim = {
            check_claim: ''
          }
          this.saveCheckClaim()
          break
        case 'student':
          this.formStudent = {
            student_claim_subject: '',
            student_claim_content: ''
          }
          this.saveStudent()
          break
        case 'proj':
          this.formProj = {
            proj_situation_online_time: '',
            proj_situation_open_time: '',
            proj_situation_student_count: '',
            proj_situation_social: 0
          }
          this.saveProj()
          break
        case 'teach':
          // this.formProj = {
          //   proj_situation_online_time: '',
          //   proj_situation_open_time: '',
          //   proj_situation_student_count: '',
          //   proj_situation_social: 0
          // }
          this.saveTeach(0)
          break
        case 'net':
          this.formNet = {
            net_claim_content: '',
            net_claim_count: ''
          }
          this.saveNet()
          break
        case 'sys':
          this.formSys = {
            sys_claim_computer: '',
            sys_claim_other: '',
            sys_claim_mobile: 0
          }
          this.saveSys()
          break
        case 'not_sys':
          this.formNotSys = {
            not_sys_claim_plugin: 0,
            not_sys_claim_plugin_name: '',
            not_sys_claim_plugin_size: '',
            not_sys_claim_plugin_link: '',
            not_sys_claim_content: ''
          }
          this.saveNotSys()
          break
        case 'hard':
          this.formHard = {
            user_hardware_claim_computer: '',
            user_hardware_claim_other: ''
          }
          this.saveHard()
          break
        case 'spec':
          this.formSpec = {
            user_special_claim_hardware: '',
            user_special_claim_other: ''
          }
          this.saveSpec()
          break
        case 'net_safe':
          this.formNetSafe = {
            net_safe_claim: ''
          }
          this.saveNetSafe()
          break
        case 'frame':
          this.formFrame = {
            frame_content: '',
            frame_file: ''
          }
          this.saveFrame()
          break
        case 'experiment_tech':
          this.formExperimentTech = {
            experiment_tech_dev: '',
            experiment_tech_tool: '',
            experiment_tech_level: ''
          }
          this.saveExperimentTech()
          break
        case 'platform':
          this.formPlatform = {
            platform_lang: '',
            platform_tool: '',
            platform_db: ''
          }
          this.savePlatform()
          break
        case 'service':
          this.formService = {
            buildArry: [],
            buildDescribe: '',
            planArry: [],
            planDescribe: ''
          }
          this.saveService(0)
          break
        case 'feature':
          this.formFeature = {
            feature_design: '',
            feature_tech: '',
            feature_appraise: '',
            feature_more: ''
          }
          this.saveFeature()
          break
        case 'intel':
          this.formIntel = {
            intellectual_register: '',
            intellectual_name: '',
            intellectual_same: '',
            intellectual_username: '',
            intellectual_power: '',
            intellectual_no: ''
          }
          this.saveIntel()
          break
        case 'materialsFile':
          this.saveMaterialsfile(0)
          break
      }
    },
    // 获取敏感词
    async getSensitiveWord() {
      await this.$http.get('/sensitiveword/', {
        params: {
          page: 1,
          size: 10000,
          status: 1
        }
      }).then((data) => {
        if (data.results.length) {
          data.results.forEach(item => {
            if (item.words) {
              const wordList = item.words.split('\n')
              for (let i = 0; i < wordList.length; i++) {
                this.sensitiveWord.push(wordList[i])
              }
            }
          })
        } else {
          this.sensitiveWord = []
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  async mounted() {
    await this.getInfo()
    this.getSensitiveWord()
  }
}
</script>

<style scoped src="../../../../assets/css/project-detail.css"></style>
<style scoped src="../../../../assets/css/table.css"></style>
<style scoped src="../../../../assets/css/chunkUpload.css"></style>
<style scoped src="../../../../assets/css/project-manage.css"></style>

<style lang="less" scoped>
.content .container {
  width: 1200px;
  margin: 0 auto;
  visibility: visible;
}

.center_content {
  .box-wrap {
    margin-top: 20px;
    padding: 40px;
    background: #fff;
    box-sizing: border-box;
  }

  .title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-right: 160px;
    padding-left: 20px;

    .title-btns {
      position: absolute;
      top: 0;
      right: 0;

      > a {
        margin-right: 10px;
        font-size: 14px;
        font-weight: lighter;
        color: #3399ff;
        cursor: pointer;

        i {
          font-size: 14px;
          margin-right: 5px;
        }
      }
    }
  }

  .title:before {
    content: "";
    width: 4px;
    height: 1em;
    background-color: #73D6CA;
    position: absolute;
    left: 0;
    top: 16px;
  }

  .mbox .lBox {
    float: left;
    width: 600px;

    .detail-base {
      font-size: 16px;
      padding: 20px 0;
      height: 376px;
      box-sizing: border-box;
      overflow-y: auto;

      .detail-item {
        display: inline-block;
        margin-right: 30px;
        padding: 10px 0;
      }

      .detail-intro {
        padding: 10px 0;

        .label {
          float: left;
        }

        p {
          padding-left: 80px;
        }
      }

      .clearfix:after {
        content: ".";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
        overflow: hidden;
      }
    }
  }

  .label {
    width: 100px;
    padding-right: 10px;
  }

  .mbox .rBox {
    float: right;
    width: 460px;

    .preview {
      padding: 6px 20px;
      border: 1px solid #73D6CA;
      color: #73D6CA;
      border-radius: 3px;
    }

    .submit {
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
    }

    .imgCover {
      width: 100%;
      height: 306px;
      margin-top: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .upload {
      width: 140px;
      height: 40px;
      line-height: 40px;
      display: block;
      margin: 10px auto;
      text-align: center;
      background: #21b295;
      color: #fff;
      border-radius: 3px;
      cursor: pointer;
      font-size: 16px;
    }
  }
  .part-content {
    .part-new-table {
      margin: 10px 0;
      border: 1px solid #ebebeb;
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      background-color: transparent;
      tr th {
        background-color: #f8faff;
        color: #999;
        font-weight: normal;
      }
    }
    .part-new-table tr th,
    .part-new-table tr td {
      padding: 8px;
      line-height: 1.42857143;
      vertical-align: middle;
      border: 1px solid #ebebeb;
      text-align: center;
    }
  }
  .item-box {
    float: left;
    width: 302px;
    position: relative;
  }

  .uploadImgPreview li img {
    width: 100%;
    margin-top: 5px;
  }

  .clearfix:after {
    content: ".";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
    overflow: hidden;
  }

  .video-box {
    .lBox {
      float: left;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }

    .video-wrap {
      width: 400px;
      height: 226px;
      margin: 10px auto 0;
      background: #000;

      video {
        width: 100%;
        height: 100%;
      }
    }

    .rBox {
      float: right;
      width: 500px;

      .upload {
        padding: 6px 20px;
        background: #73D6CA;
        color: #fff;
        border-radius: 3px;
      }
    }
  }

  .menu-box {
    overflow: hidden;
    border-bottom: 1px solid #eee;

    ul {
      li {
        text-align: center;
        float: left;
        margin-right: 10px;

        a {
          display: block;
          padding: 10px;
          font-size: 16px;
          color: #002900;
          text-decoration: none;
          border-bottom: 3px solid #fff;
        }

        &:hover a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }

      .onActive {
        a {
          color: #73D6CA;
          border-color: #73D6CA;
        }
      }
    }
  }

  .part {
    min-height: 390px;
    margin-top: 30px;
  }
}
.form_contentEdit .label {
  width: 100px !important;
}
.form_content .k-container {
  max-width: 640px;
  width: 640px;
  .item-table {
    width: 640px;
    input {
      width: 100%;
      border: none;
    }
  }
  .item-table th,
  .item-table td {
    border-bottom: 1px solid #ddd;
    border-right: 1px solid #ddd;
    text-align: center;
    padding-bottom: 1px;
  }
}
.teachItem {
  p {
    font-weight: 600;
  }
  .link {
    color: #0b80ff;
    margin: 10px 0;
    display: block;
  }
}
.teachEdit {
  .m-r {
    color: #333333;
    font-weight: 500;
    display: inline-block;
    width: 150px;
    input {
      position: relative;
      top: -1px;
      margin-right: 7px;
    }
  }
  .file {
    color: #0b80ff;
    display: block;
    .del {
      margin-left: 10px;
      font-size: 22px;
      color: #c7254e;
      cursor: pointer;
      margin: 0;
      background: transparent;
      top: 3px;
      position: relative;
    }
  }
  .upload {
    display: block;
    text-align: center;
    width: 55px;
    line-height: 30px;
    background: #f19830;
    color: #fff;
    cursor: pointer;
  }
}
.warn {
  p {
    font-size: 12px;
    color: #df3d3e;
  }
  span {
    font-size: 12px;
    color: #337ab7;
    cursor: pointer;
  }
}
.NumCount {
  display: inline-block;
  text-align: center;
  width: 40px;
  border-bottom: 1px solid #999;
}
.teach_Item {
  color: #666;
  .text {
    width: 40px !important;
    height: 20px !important ;
    line-height: 23px !important;
    border: none !important;
    text-align: center;
    border-bottom: 1px solid #999 !important;
  }
}
.form_overlay {
  z-index: 100 !important;
}

.file-upload {
  z-index: 200 !important;
}

.menu-list > li.on a,
.menu-list > li:hover a {
  color: #73D6CA !important;
  border-color: #73D6CA !important;
}
.signPic {
  max-height: 20px;
  max-width: 120px;
  vertical-align: middle;
  display: inline-block;
  margin-top: -3px;
  margin-right: 25px;
}
.del-icon {
  color: #ff0000;
  position: relative;
  display: inline-block;
  border: 1px solid #ddd;
  font-size: 12px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 20px;
  right: 17px;
  top: -12px;
  cursor: pointer;
}
.url_link {
  flex: 1;
  overflow-x: auto;
  white-space: nowrap;
}
.url_link::-webkit-scrollbar {
  display: none;
}
.form_control {
  text-align: center;
}
.form_control a {
  float: none;
  display: inline-block;
}
.addOtherUser {
  display: inline-block;
  color: #ffffff;
  margin-left: 15px;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 4px;
  background-color: #028c8c;
  border-color: #028c8c;
  cursor: pointer;
}
.infor span {
  font-size: 14px;
  color: #333;
  margin-right: 20px;
  display: inline-block;
  margin-bottom: 10px;
  display: inline-block;
}
.infor span i {
  color: #999;
}
.person {
  position: relative;
  overflow: hidden;
}
.person_symbol {
  position: absolute;
  left: -20px;
  top: 4px;
  background: #ff2424;
  color: #fff;
  width: 70px;
  text-align: center;
  font-size: 12px;
  transform: rotate(-45deg);
  -ms-transform: rotate(-45deg); /* Internet Explorer 9*/
  -moz-transform: rotate(-45deg); /* Firefox */
  -webkit-transform: rotate(-45deg); /* Safari 和 Chrome */
  -o-transform: rotate(-45deg); /* Opera */
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
}
.tips {
  margin-bottom: 10px;
  color: rgb(144, 144, 144);
}
.content_underline {
  text-decoration: underline;
  margin: 0 10px;
}
</style>
